const VersionCheckPlugin = {
  install() {
    let currentVersion = null;

    const checkVersion = async () => {
      try {
        const resp = await fetch('/api/public/version', { cache: 'no-store' });
        if (!resp.ok) return;
        const { version } = await resp.json();
        if (currentVersion == null) {
          currentVersion = version;
        } else if (currentVersion !== version) {
          window.location.reload(true);
        }
      } catch (e) {
        // verkkovirhe — ohitetaan
      }
    };

    checkVersion();
    setInterval(checkVersion, 5 * 60 * 1000);
  },
};

export default VersionCheckPlugin;
